/**
 * 时间工具函数
 * 后端存储 UTC 时间，前端显示时转换为用户本地时区
 */

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// 启用 UTC 和时区插件
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Return the current time in the reporting timezone used by the analytics API.
 */
export function getBeijingNow() {
  return dayjs().tz('Asia/Shanghai');
}

/**
 * 格式化为本地时间
 * @param time UTC 时间字符串
 * @param format 格式化模板，默认 'YYYY-MM-DD HH:mm:ss'
 * @returns 本地时间字符串
 */
export function formatLocalTime(time: string | null | undefined, format: string = 'YYYY-MM-DD HH:mm:ss'): string {
  if (!time) return '-';
  // 数据库存储的是 UTC 时间，转换为用户本地时区显示
  return dayjs.utc(time).local().format(format);
}

/**
 * 格式化为本地日期
 * @param time UTC 时间字符串
 * @returns 本地日期字符串 (YYYY-MM-DD)
 */
export function formatLocalDate(time: string | null | undefined): string {
  return formatLocalTime(time, 'YYYY-MM-DD');
}

/**
 * 格式化为本地时间（精确到分钟）
 * @param time UTC 时间字符串
 * @returns 本地时间字符串 (YYYY-MM-DD HH:mm)
 */
export function formatLocalTimeShort(time: string | null | undefined): string {
  return formatLocalTime(time, 'YYYY-MM-DD HH:mm');
}

// 保留旧函数名作为别名，保持向后兼容
export const formatBeijingTime = formatLocalTime;
export const formatBeijingDate = formatLocalDate;
export const formatBeijingTimeShort = formatLocalTimeShort;
